(() => {
  const hyphenatedElements = document.querySelectorAll(".card-text-wrap");
  if (hyphenatedElements.length === 0) {
    return;
  }

  const htmlLang = document.documentElement.getAttribute("lang") || "de";
  const normalizedLang = htmlLang.toLowerCase();
  const language = normalizedLang.startsWith("de")
    ? "de"
    : normalizedLang.startsWith("fr")
      ? "fr"
      : normalizedLang.startsWith("en")
        ? "en-us"
        : "de";
  if (!document.documentElement.getAttribute("lang")) {
    document.documentElement.setAttribute("lang", language);
  }
  hyphenatedElements.forEach((element) => {
    if (!element.getAttribute("lang")) {
      element.setAttribute("lang", language);
    }
  });

  const basePath =
    (window.drupalSettings &&
      window.drupalSettings.path &&
      (window.drupalSettings.path.basePath ||
        window.drupalSettings.path.baseUrl)) ||
    "/";

  const config = {
    require: {
      de: "Silbentrennungsalgorithmus",
      fr: "anticonstitutionnellement",
      "en-us": "supercalifragilisticexpialidocious",
    },
    setup: {
      defaultLanguage: language,
      selectors: {
        ".card-text-wrap": {
          minWordLength: 6,
          leftmin: 2,
          rightmin: 2,
        },
      },
    },
    paths: {
      maindir: `${basePath}themes/custom/b5nova/dist/hyphenopoly/`,
      patterndir: `${basePath}themes/custom/b5nova/dist/hyphenopoly/patterns/`,
    },
  };
  window.__b5novaHyphenopolyConfig = config;

  if (window.Hyphenopoly && typeof window.Hyphenopoly.config === "function") {
    window.Hyphenopoly.config(config);
    return;
  }

  window.Hyphenopoly = config;
  const script = document.createElement("script");
  script.src = `${basePath}themes/custom/b5nova/dist/hyphenopoly/Hyphenopoly_Loader.js`;
  script.defer = true;
  document.head.appendChild(script);
})();
